import { defineMessages } from 'react-intl';

export const addressValidationMessages = defineMessages({
  validateButton: {
    defaultMessage: 'Validate Address',
    id: 'UfiW7L',
    description: 'Button to trigger backend address validation for the Ship To address',
  },
  revalidateButton: {
    defaultMessage: 'Re-validate',
    id: 'Y0gnhe',
    description: 'Button to re-run address validation after a warning or error',
  },
  suggestedResidential: {
    defaultMessage: 'Suggested Residential Address',
    id: 'tzs36g',
    description: 'Card title when the validated address is classified as residential',
  },
  suggestedCommercial: {
    defaultMessage: 'Suggested Commercial Address',
    id: 'ObmomP',
    description: 'Card title when the validated address is classified as commercial',
  },
  useThisAddress: {
    defaultMessage: 'Use this Address',
    id: 'SBx7+G',
    description: 'Button to apply the suggested/normalized address from validation',
  },
  validationError: {
    defaultMessage: 'Address validation error',
    id: 'ByAnWD',
    description: 'Alert title shown when address validation returns an error or warning',
  },
  validationNetworkError: {
    defaultMessage: 'Unable to validate address. Please try again.',
    id: 'W14q0l',
    description: 'Message shown when address validation fails due to a network or server error',
  },
  addressVerified: {
    id: '2vf80m',
    defaultMessage: 'Address Verified',
    description: 'Label shown when a Ship To address was previously verified and no suggestion is available',
  },
});
